export enum DataSetEventStatusTypeEnums {
    /**
     * No error
     */
    OK = 0,
    /**
     * Not synced yet
     */
    UNSYNCED = 1,
    /**
     * cant sync, no connection to api/network?
     */
    ERROR_SYNC = 2,
    /**
     * api returns an error on sync
     */
    ERROR_API = 3,
}
